<template>
	<div class="login-container2">
		<div v-if="envConfig.isBxIe()">
			<div class="login-deco1"></div>
			<div class="login-deco2"></div>
			<div class="login-deco3"></div>
		</div>
		<div v-else>
			<div class="login-right-bg"></div>
		</div>
		<div class="login-weaper animated bounceInDown">
			<p class="login-tip">{{ website.title }}</p>
			<div class="login-border">
				<div class="login-main">
					<h4 class="login-title"></h4>
					<userLogin v-if="activeName === 'user'" ref="refUser" />
					<codeLogin v-else-if="activeName === 'code'" ref="refCode" />
					<div v-if="activeName === 'user'" class="login-menu">
						<a class="active">账号密码</a>
						<a class="deactive" href="#" @click.stop="activeName = 'code'">手机号登录</a>
					</div>
					<div v-else-if="activeName === 'code'" class="login-menu">
						<a class="deactive" href="#" @click.stop="activeName = 'user'">账号密码</a>
						<a class="active">手机号登录</a>
					</div>
				</div>
			</div>
		</div>
		<div class="login-copyright">
			<a>{{ website.copyright }}</a>
			<a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #1e9fff" target="_blank">
				{{ website.icp }}
			</a>
			<br />
			<a>经营保险经纪业务许可证编号:269602000000800</a>
			<a href="http://icid.iachina.cn/" style="color: #1e9fff" target="_blank">中国保监会网销许可</a>
		</div>
		<top-color v-show="false" />

		<div class="login-end-hint" v-if="isShowEndHint">
			<div class="login-end-hint-content">
				<div class="login-end-hint-content-title">停用公告</div>
				<el-image src="/images/icon_end.png" :style="{width: '100%', height: '80px'}"></el-image>
				<div class="login-end-hint-content-text">
					<div style="color: red">本网站从即日起已停止服务。</div>
					<div>如有疑问，请前往我们的企微服务群，或联系您的业务对接人进行咨询。</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {fetchList} from '@/api/admin/tenant'
import userLogin from './userlogin'
import codeLogin from './codelogin'
//import thirdLogin from './thirdlogin'
import resetPassword from './resetpassword'
import {mapGetters} from 'vuex'
import {getStore, setStore, clearStore} from '@/util/store'
import {oauthUrl} from '@/config/env'
import topColor from '@/page/index/top/top-color'
import channelDif from '@/util/channelUtil'

export default {
	name: 'Login',
	components: {
		userLogin,
		codeLogin,
		resetPassword,
		//thirdLogin,
		topColor,
	},
	data() {
		return {
			tenantList: [],
			active: '',
			activeName: 'user',
			isShowEndHint: false,
		}
	},
	watch: {
		$route: {
			handler() {
				//直接跳转登录
				this.onInterByUrl()
			},
			immediate: true,
		},
	},
	created() {
		// this.watermark()
		this.getTenantList()
		this.active = getStore({name: 'tenantId'})
	},
	mounted() {
		//通过query判断是否从万能进入的
		let {secretType123 = '', name = '', code = ''} = this.$route.query || {}
		if (secretType123) {
			this.activeName = secretType123 === '1' ? 'user' : 'code'
			this.$nextTick(() => {
				const refData = this.$refs[secretType123 === '1' ? 'refUser' : 'refCode']
				if (refData) {
					refData.setLoginData(name, code)
				}
			})
			return
		}
		let login = getStore({name: 'login'})
		if (this.validatenull(login)) {
			return
		}
		let forceRefresh = login.forceRefresh
		if (this.validatenull(forceRefresh)) {
			return
		}
		if (forceRefresh) {
			setStore({name: 'login', content: {forceRefresh: false}})
			this.$router.go(this.$router.currentRoute)
		}
	},
	computed: {
		...mapGetters(['website', 'tagWel']),
	},
	methods: {
		//外部通过URL直接访问
		async onInterByUrl() {
			console.log(this.$route.query, '------------')
			let {
				code = '',
				state = '',
				type = '',
				from = '',
				productId = '',
				insureType = '',
				productIdCenter = '',
				appId = '',
				fromTypeChannel = '',
			} = this.$route.query || {}
			// 统一登录重定向
			const {isHttps, isBxIeBw, isLocalHost, getBxRelaunchUrl} = this.envConfig
			//博维跳转吉泰美保，如果没有htts,则也跳转至吉泰
			// if (!isLocalHost() && isBxIeBw()) {
			// 	this.isShowEndHint = true
			// 	return
			// }
			if ('unity' === from) {
				//非分销员，则清空
				setStore({name: 'userInfoLocal', content: {}})
				window.location.href = oauthUrl
				return
			}
			if (code !== '' && state !== '') {
				//http://120.55.53.242/#/login?state=AUTHCODE&code=77f7cca0-a416-437e-ac67-d3eac2717ec4&type=plan&productId=98&insureType=6
				//基本数据处理
				let tempMethod = 'LoginBySocial'
				let tempPath = this.tagWel.value
				//跳转计划书
				//跳转工种核查
				if (type === 'plan' || type == 'gzhc' || type === 'planList' || type === 'material' || type === 'statement') {
					//清空token
					await this.$store.dispatch('LogOut')
					//渠道控制 都是泛高空进入的
					let channelType = channelDif[fromTypeChannel]
					channelType.appId = appId
					this.$store.commit('SET_DIF_CHANNEL_TYPE', channelType)
					tempMethod = 'loginByAuthCode'
					switch (type) {
						case 'plan':
							tempPath = '/plan/planInsure'
							break
						case 'gzhc':
							tempPath = '/workVerification/index'
							break
						case 'planList':
							tempPath = '/plan/planListIndex'
							break
						case 'material':
							tempPath = '/material/materialList'
							break
						case 'statement':
							tempPath = '/statement/index'
							break
					}
					// tempPath = type === "plan" ? "/plan/planInsure" : "/workVerification/index";
				}

				//loading
				const loading = this.$loading({
					lock: true,
					text: `登录中,请稍后。。。`,
					spinner: 'el-icon-loading',
				})
				try {
					await this.$store.dispatch(tempMethod, {state, code, tId: '1'})
					await this.$store.dispatch('getInsureTypes')
					this.$forceUpdate()
					console.log('跳转阿里')
					//跳转
					await this.$router.replace({
						path: tempPath,
						query: productId ? {productId, insureType, productIdCenter} : {},
					})
				} catch (e) {
					this.$alert(e.message, '提示', {confirmButtonText: '我知道了'}).then(() => {})
				} finally {
					loading.close()
				}
				// this.$store
				//     .dispatch(tempMethod, {state, code})
				//     .then(() => {
				//       //获取insureTypes
				//       this.$store.dispatch('getInsureTypes').then(() => {
				//
				//       }).catch(() => {}).finally(() => {
				//         loading.close();
				//       })
				//     })
				//     .catch(() => {
				//       loading.close();
				//     })
			} else {
				this.$store.commit('SET_DIF_CHANNEL_TYPE', {})

				//获取本地登录数据，如果存在，则直接登录
				this.getLocalLoginData()
			}
		},
		handleCommand(command) {
			setStore({name: 'tenantId', content: command})
		},
		getTenantList() {
			fetchList().then((response) => {
				this.tenantList = response.data.data
			})
		},
		watermark() {
			const text = ''
			const canvas = document.createElement('canvas')
			canvas.width = '500'
			canvas.height = '200'
			const ctx = canvas.getContext('2d')
			ctx.clearRect(0, 0, 200, 200) // 绘制之前画布清除
			ctx.font = '30px 黑体'
			ctx.rotate((-20 * Math.PI) / 180) // 为了实现水印倾斜效果,旋转画布坐标系
			ctx.fillStyle = 'rgba(100,100,100,0.15)' // 画笔颜色
			ctx.fillText(text, -20, 200) // 书写的内容及位置
			ctx.rotate('20*Math.PI/180') // 坐标系还原,如果后续没有其他操作,这一步可以省略
			// 将canvas的内容转换为base64编码
			const data = canvas.toDataURL('image/png', 1) // 1表示质量(无损压缩)

			window.onload = () => {
				const background = 'url(' + data + ') repeat'
				var watermark = document.createElement('div')
				watermark.style.width = '100%'
				watermark.style.height = '100%'
				watermark.style.position = 'fixed'
				watermark.style.left = '0'
				watermark.style.top = '0'
				watermark.style.pointerEvents = 'none'
				watermark.style.background = background
				watermark.style.zIndex = '99999'
				document.body.append(watermark)
			}
		},
		//获取本地登录数据
		getLocalLoginData() {
			//存在数据，并且是1个小时内的，则直接登录
			const userInfo = getStore({name: 'userInfoLocal'}) || {}
			//解构
			const {user_info: {userType = ''} = {}, access_token_time = 0} = userInfo
			if (!userType) {
				return
			}
			//不是分销员，或者时间差8个小时
			if (userType !== 'dist' || Date.now() - access_token_time > 1000 * 60 * 60 * 7) {
				//非分销员，则清空
				setStore({name: 'userInfoLocal', content: {}})
				return
			}
			this.$store.dispatch('LoginLocalData', userInfo)
			setTimeout(() => {
				this.$router.push({path: this.tagWel.value})
			}, 500)
		},
	},
}
</script>
<style lang="scss">
@import '~@/styles/login.scss';

.el-message-box__header {
	display: flex;
	justify-content: center;
	.el-message-box__title {
		font-weight: bold;
	}
}

.login-end-hint {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;

	.login-end-hint-content {
		width: 400px;
		height: 200px;
		background-color: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;

		.login-end-hint-content-title {
			position: absolute;
			top: 10px;
			left: 0;
			width: 100%;
			height: 40px;
			color: #1a1818;
			font-size: 20px;
			font-weight: bold;
			text-align: center;
			line-height: 40px;
			z-index: 1000;
		}
	}

	.login-end-hint-content-text {
		padding: 10px 20px 0;
		color: #131313;
		font-size: 14px;
		font-weight: bold;
		text-indent: 1em;
		line-height: 26px;
	}
}
</style>
